import BasicModal from '../../components/shared/modals/BaseModal'
import React, { useState, useEffect } from 'react'
import { IconButton, Grid, LinearProgress } from '@mui/material'
import { object, any } from 'prop-types'
import StatusRhChip from '../../components/shared/StatusRhChip'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import { Postagens } from '../../services/http'

const OpenButton = ({ ...props }) => {
  return (
    <IconButton color="leitura" {...props}>
      <StatusRhChip value={props?.postagem?.statusRh} />
    </IconButton>
  )
}

OpenButton.propTypes = {
  postagem: any
}
export default function VisualizarPostagemModal({ postagem }) {
  const [status, setStatus] = useState(false)
  const [plagio, setPlagio] = useState('')
  const [loading, setLoading] = useState(false)

  const getPlagio = async id => {
    setLoading(true)
    const { data } = await Postagens().show({
      id,
      'includes[]': 'plagio'
    })
    setLoading(false)
    setPlagio(data.data[0]?.plagio.html_plagio)
  }

  useEffect(() => {
    if (status === true) getPlagio(postagem.id)
  }, [status])

  return (
    <BasicModal
      title="Plágio"
      sx={{
        width: { xs: '100vw', md: '60vw' }
      }}
      status={status}
      Caller={({ ...props }) => <OpenButton {...props} postagem={postagem} />}
      closeEvent={event => setStatus(event)}
    >
      <>
        <AdaptativeGridContainer
          sx={{ justifyContent: 'space-between' }}
          rowSpacing={2}
        >
          <>
            <Grid
              className="plagio-iframe-container"
              item
              xs={12}
              md={12}
              lg={12}
            >
              {loading ? (
                <LinearProgress />
              ) : plagio ? (
                <div dangerouslySetInnerHTML={{ __html: plagio }} />
              ) : (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  Não há ocorrência de plágio
                </div>
              )}
            </Grid>
          </>
        </AdaptativeGridContainer>
      </>
    </BasicModal>
  )
}

VisualizarPostagemModal.propTypes = {
  postagem: object
}
